
import { Component, computed, inject, input } from '@angular/core';

import { ResourcesService } from '@mitsubishi/core';

import { isNil } from '@angular-ru/cdk/utils';

@Component({
  selector: 'apm-table-wrapper-cell',
  imports: [],
  templateUrl: './table-wrapper-cell.component.html',
})
export class TableWrapperCellComponent {
  readonly value = input.required<any>();
  readonly props = input.required<any>();

  #resourcesService = inject(ResourcesService);

  readonly shouldTranslate = computed(() => {
    const props = this.props();
    if (isNil(props)) {
      return false;
    }

    return props.dataType == 3;
  });

  readonly uom = computed(() => {
    return this.props()?.rowData?.uom;
  });

  readonly normalizedValue = computed(() => {
    const value = this.value();
    if (isNil(value) || value === '') {
      return '-';
    }

    return this.shouldTranslate() ? this.#resourcesService.getTextResource(value) : value;
  });
}
